/** Inline validation copy shown next to a field (not a page-level banner). */
export default function BuilderStepInlineError({ message, className = 'mt-2' }) {
  if (!message) return null
  return (
    <p className={`text-sm text-red-600 ${className}`.trim()} role="alert">
      {message}
    </p>
  )
}
